import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const ease = [0.76, 0, 0.24, 1];

function Line({ children, delay }) {
  return (
    <span className="reveal-line">
      <motion.span
        className="block"
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.2, ease, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);

  return (
    <section id="hero" ref={ref} className="relative min-h-screen overflow-hidden" data-testid="hero-section">
      <motion.div style={{ y, scale }} className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/16300516/pexels-photo-16300516.jpeg"
          alt="Композиция от изкуствени цветя"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-cream via-cream/30 to-transparent" />
        <div className="absolute inset-0 bg-cream/10" />
      </motion.div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 min-h-screen flex flex-col justify-end pb-24 pt-32">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 1 }}
          className="text-xs uppercase tracking-[0.3em] text-clay font-medium mb-8"
          data-testid="hero-eyebrow"
        >
          Ръчно изработени · Вечни цветя
        </motion.p>

        <h1 className="font-serif text-ink text-5xl sm:text-7xl lg:text-[6.5rem] leading-[0.92] tracking-tight max-w-5xl">
          <Line delay={0.1}>Цветя, които</Line>
          <Line delay={0.22}>
            <span className="italic text-clay">никога</span> не увяхват
          </Line>
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.1, duration: 1 }}
          className="mt-10 flex flex-col sm:flex-row sm:items-end gap-8 justify-between"
        >
          <p className="text-lg text-stone font-light max-w-md leading-relaxed">
            Всяка композиция е създадена на ръка от Айлян — уникална, в различни размери, за да пасне на вашето
            пространство и повод.
          </p>
          <a
            href="#collection"
            className="group inline-flex items-center gap-3 self-start bg-ink text-cream px-8 py-4 rounded-full text-sm font-medium hover:bg-clay transition-colors duration-300"
            data-testid="hero-cta"
          >
            Разгледай колекцията
            <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
